import axios from 'axios';
import React, { useState, useEffect, useRef } from 'react'
import { BASE_URL, getBearerToken, SOCKET_BASE_URL } from '../../utils/Apis';
import { Constants } from '../../utils/Constants';
import users from "../assets/image/users.png"
import host from "../assets/image/host.png"
const A_participants = () => {

    const [data, setdata] = useState([])
    const [unmuteData, setunmuteData] = useState([])
    const [_id, set_id] = useState("")
    const socketRef = useRef(null);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         handleParticipantClick();
    //     }, 2000); // 2000ms = 2 seconds

    //     // Cleanup on unmount
    //     return () => clearInterval(interval);
    // }, []);


    // const handleParticipantClick = () => {
    //     let token = localStorage.getItem(Constants.APP_KEY)

    //     let config = {
    //         method: 'get',
    //         maxBodyLength: Infinity,
    //         url: BASE_URL + 'fetchSaveParticipants',
    //         headers: {
    //             'Authorization': 'Bearer ' + token
    //         }
    //     };

    //     axios.request(config)
    //         .then((response) => {
    //             console.log(JSON.stringify(response.data.data?.participants));
    //             setdata(response.data.data?.participants)
    //             setunmuteData(response.data.data?.participants.filter((item) => item.isMuted == false))
    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }

    const connectWebSocket = () => {
        // if (!_id) return alert("Please enter User ID");

        // if (_id) {
        // Connect to WebSocket server
        socketRef.current = new WebSocket(SOCKET_BASE_URL); // Update port if using HTTPS

        socketRef.current.onopen = () => {
            console.log('WebSocket connected', localStorage.getItem(Constants.USERID));

            // Send REGISTER message
            socketRef.current.send(JSON.stringify({
                type: 'REGISTER',
                _id: localStorage.getItem(Constants.USERID)
            }));
        };

        socketRef.current.onmessage = (event) => {
            const data = JSON.parse(event.data);
            console.log('Received:', data);

            if (data.type === 'USER_UPDATED') {
                setdata(data.payload.participants);
                setunmuteData(data.payload.participants.filter((item) => item.isMuted == false));
            }
        };

        socketRef.current.onclose = () => {
            console.log('WebSocket disconnected');
        };

        socketRef.current.onerror = (err) => {
            console.error('WebSocket error:', err);
        };
        // }
    };

    useEffect(() => {
        // fetch_users()
        return () => {
            console.log("unmount")
        }
    }, [])
    useEffect(() => {
        connectWebSocket()
    }, [])

    useEffect(() => {
        return () => {
            if (socketRef.current) socketRef.current.close();
        };
    }, []);

    // const fetch_users = async () => {
    //     getBearerToken("users").then((result) => {
    //         if (result.error == 0) {
    //             console.log(result.data)
    //             set_id(result?.data?._id)
    //         } else {
    //         }
    //     })
    // }


    return (
        <>
            <div className="grid grid-cols-12 gap-3">
                <div className="col-span-3">
                    <div className="bg-primary flex w-full rounded-md   p-3" style={{ justifyContent: "space-between", alignItems: "center" }}>
                        <div className="">
                            <h3 style={{ fontSize: "22px" }}>{unmuteData.length}</h3>
                            <h5 style={{ fontSize: "20px" }}>Total Speaking</h5>
                        </div>
                        <div className="">
                            <img src={users} className='bg-white  p-3 rounded-full' alt="" style={{ width: "80px" }} />
                        </div>
                    </div>

                </div>
                <div className="col-span-3">
                    <div className="bg-success flex w-full rounded-md   p-3" style={{ justifyContent: "space-between", alignItems: "center" }}>
                        <div className="">
                            <h3 style={{ fontSize: "22px" }}>{data.length}</h3>
                            <h5 style={{ fontSize: "20px" }}>Online Users</h5>
                        </div>
                        <div className="">
                            <img src={host} className='bg-white  p-3 rounded-full' alt="" style={{ width: "80px" }} />
                        </div>
                    </div>

                </div>

            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', marginTop: 20, marginBottom: 20 }}>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        padding: '10px',
                        backgroundColor: '#f0f0f0',
                    }}
                >
                    <h2 style={{ marginBottom: '20px', backgroundColor: "black", color: "white", padding: 15, textAlign: "left" }}> Unmute Participants</h2>
                    {unmuteData && unmuteData.length > 0 ?
                        <div
                            style={{
                                display: 'flex',
                                // flexWrap: 'wrap',
                                justifyContent: 'flex-start',
                                gap: '10px',
                                width: "10%",
                                height: "50%",
                                flexDirection: "row"
                            }}
                        >
                            {unmuteData?.map((item, i) => (
                                <div
                                    key={i}
                                    style={{
                                        flex: '0 0 12.5%',

                                        backgroundColor: item.isMuted ? "red" : "green",
                                        color: 'white',
                                        padding: '15px',
                                        borderRadius: '1px',
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                    }}
                                >
                                    <span style={{ color: "white" }}>{item.userName}</span>
                                    {/* <span role="img" aria-label="mic">🎤</span> */}

                                </div>
                            ))}
                        </div> : <div style={{ height: 50 }}></div>}
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '100%',
                        padding: '10px',
                        backgroundColor: '#f0f0f0',
                    }}
                >
                    <h2 style={{ marginBottom: '20px', backgroundColor: "black", color: "white", padding: 15, textAlign: "left" }}>Participants</h2>
                    {data && data.length > 0 ?

                        <div
                            style={{
                                display: 'flex',
                                // flexWrap: 'wrap',
                                justifyContent: 'flex-start',
                                gap: '10px',
                                width: "10%",
                                height: "50%",
                                flexDirection: "row",
                                // background: "blue"

                            }}
                        >
                            {data?.map((item, i) => (
                                item.userName != "" ?
                                    <div
                                        key={i}
                                        style={{
                                            flex: '0 0 12.5%',
                                            backgroundColor: item.isMuted ? "red" : "green",
                                            color: 'white',
                                            padding: '15px',
                                            borderRadius: '1px',
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <span style={{ color: item.isMuted ? "black" : "white" }}>{item.userName}</span>
                                        {/* <span role="img" aria-label="mic">🎤</span> */}

                                    </div> : null
                            ))}
                        </div> : <div style={{ height: 50 }}></div>}
                </div>
            </div>
        </>

    )
}

export default A_participants